"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnDeUsd = exports.EnDePln = exports.EnDeNok = exports.EnDeCzk = exports.EnDeDkk = exports.EnDeEur = exports.DeDeUsd = exports.DeDePln = exports.DeDeNok = exports.DeDeCzk = exports.DeDeDkk = exports.DeDeEur = void 0;
class DeDeEur {
    constructor() {
        this.locale = "de-de";
        this.dateFormat = {
            short: "dd.MM.yyyy",
            medium: "dd.MMMM yyyy",
            long: "dddd dd.MMMM yyyy",
        };
        this.currencyFormat = {
            code: "EUR",
            symbol: "€",
            decimalSeparator: ",",
            groupSeparator: ".",
            positivePattern: "n C",
            negativePattern: "-n C"
        };
    }
}
exports.DeDeEur = DeDeEur;
class DeDeDkk {
    constructor() {
        this.locale = "de-de";
        this.dateFormat = {
            short: "dd.MM.yyyy",
            medium: "dd.MMMM yyyy",
            long: "dddd dd.MMMM yyyy",
        };
        this.currencyFormat = {
            code: "DKK",
            symbol: "DKK",
            decimalSeparator: ",",
            groupSeparator: ".",
            positivePattern: "C n",
            negativePattern: "C -n"
        };
    }
}
exports.DeDeDkk = DeDeDkk;
class DeDeCzk {
    constructor() {
        this.locale = "de-de";
        this.dateFormat = {
            short: "dd.MM.yyyy",
            medium: "dd.MMMM yyyy",
            long: "dddd dd.MMMM yyyy",
        };
        this.currencyFormat = {
            code: "CZK",
            symbol: "CZK",
            decimalSeparator: ",",
            groupSeparator: ".",
            positivePattern: "C n",
            negativePattern: "C -n"
        };
    }
}
exports.DeDeCzk = DeDeCzk;
class DeDeNok {
    constructor() {
        this.locale = "de-de";
        this.dateFormat = {
            short: "dd.MM.yyyy",
            medium: "dd.MMMM yyyy",
            long: "dddd dd.MMMM yyyy",
        };
        this.currencyFormat = {
            code: "NOK",
            symbol: "NOK",
            decimalSeparator: ",",
            groupSeparator: ".",
            positivePattern: "C n",
            negativePattern: "C -n"
        };
    }
}
exports.DeDeNok = DeDeNok;
class DeDePln {
    constructor() {
        this.locale = "de-de";
        this.dateFormat = {
            short: "dd.MM.yyyy",
            medium: "dd.MMMM yyyy",
            long: "dddd dd.MMMM yyyy",
        };
        this.currencyFormat = {
            code: "PLN",
            symbol: "PLN",
            decimalSeparator: ",",
            groupSeparator: ".",
            positivePattern: "C n",
            negativePattern: "C -n"
        };
    }
}
exports.DeDePln = DeDePln;
class DeDeUsd {
    constructor() {
        this.locale = "de-de";
        this.dateFormat = {
            short: "dd.MM.yyyy",
            medium: "dd.MMMM yyyy",
            long: "dddd dd.MMMM yyyy",
        };
        this.currencyFormat = {
            code: "USD",
            symbol: "$",
            decimalSeparator: ".",
            groupSeparator: ",",
            positivePattern: "C n",
            negativePattern: "C -n"
        };
    }
}
exports.DeDeUsd = DeDeUsd;
class EnDeEur {
    constructor() {
        this.locale = "en-de";
        this.dateFormat = {
            short: "dd/MM/yyyy",
            medium: "MMMM dd, yyyy",
            long: "dddd MMMM dd, yyyy",
        };
        this.currencyFormat = {
            code: "EUR",
            symbol: "€",
            decimalSeparator: ",",
            groupSeparator: ".",
            positivePattern: "n C",
            negativePattern: "-n C"
        };
    }
}
exports.EnDeEur = EnDeEur;
class EnDeDkk {
    constructor() {
        this.locale = "en-de";
        this.dateFormat = {
            short: "dd/MM/yyyy",
            medium: "MMMM dd, yyyy",
            long: "dddd MMMM dd, yyyy",
        };
        this.currencyFormat = {
            code: "DKK",
            symbol: "DKK",
            decimalSeparator: ",",
            groupSeparator: ".",
            positivePattern: "C n",
            negativePattern: "C -n"
        };
    }
}
exports.EnDeDkk = EnDeDkk;
class EnDeCzk {
    constructor() {
        this.locale = "en-de";
        this.dateFormat = {
            short: "dd/MM/yyyy",
            medium: "MMMM dd, yyyy",
            long: "dddd MMMM dd, yyyy",
        };
        this.currencyFormat = {
            code: "CZK",
            symbol: "CZK",
            decimalSeparator: ",",
            groupSeparator: ".",
            positivePattern: "C n",
            negativePattern: "C -n"
        };
    }
}
exports.EnDeCzk = EnDeCzk;
class EnDeNok {
    constructor() {
        this.locale = "en-de";
        this.dateFormat = {
            short: "dd/MM/yyyy",
            medium: "MMMM dd, yyyy",
            long: "dddd MMMM dd, yyyy",
        };
        this.currencyFormat = {
            code: "NOK",
            symbol: "NOK",
            decimalSeparator: ",",
            groupSeparator: ".",
            positivePattern: "C n",
            negativePattern: "C -n"
        };
    }
}
exports.EnDeNok = EnDeNok;
class EnDePln {
    constructor() {
        this.locale = "en-de";
        this.dateFormat = {
            short: "dd/MM/yyyy",
            medium: "MMMM dd, yyyy",
            long: "dddd MMMM dd, yyyy",
        };
        this.currencyFormat = {
            code: "PLN",
            symbol: "PLN",
            decimalSeparator: ",",
            groupSeparator: ".",
            positivePattern: "C n",
            negativePattern: "C -n"
        };
    }
}
exports.EnDePln = EnDePln;
class EnDeUsd {
    constructor() {
        this.locale = "en-de";
        this.dateFormat = {
            short: "dd/MM/yyyy",
            medium: "MMMM dd, yyyy",
            long: "dddd MMMM dd, yyyy",
        };
        this.currencyFormat = {
            code: "USD",
            symbol: "$",
            decimalSeparator: ".",
            groupSeparator: ",",
            positivePattern: "C n",
            negativePattern: "C -n"
        };
    }
}
exports.EnDeUsd = EnDeUsd;
